import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mrr-skeleton',
  templateUrl: './mrr-skeleton.component.html',
  styleUrls: ['./mrr-skeleton.component.scss']
})
export class MrrSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
